export default __webpack_public_path__ + "assets/c856f4b9431ae33bd2ffaad142461fad.woff2";